// ═══ WHY A SESSION ENDED (Philip, 2026-10-10 — mid-entry sign-outs, docs/signout-investigation.md) ═══
// Before calling signOut() the app records WHY in localStorage, which every Wigley tab shares. A tab receiving
// SIGNED_OUT reads it to tell a DELIBERATE sign-out (the Sign out button; 60 minutes idle in every tab) from one
// the server made (session time limit, revoked elsewhere, a refused token refresh) — the first goes to the login
// screen, the second keeps the screen under a sign-in box (App.js). The login screen and the box say which.
// Wrapped in try/catch throughout: storage can be blocked, and a missing record only means "unexpected".
const KEY = 'wh_signout';
export const DELIBERATE_WINDOW_MS = 60 * 1000;      // a SIGNED_OUT within this of a recorded intent is that intent

export function recordSignout(reason, now = Date.now()) {
  try { localStorage.setItem(KEY, JSON.stringify({ reason, at: now })); } catch (e) { /* storage blocked */ }
}

export function readSignout() {
  try { const v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.reason ? v : null; } catch (e) { return null; }
}

export function clearSignout() {
  try { localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
}

// Was this SIGNED_OUT one we asked for? A recorded 'manual' or 'idle' sign-out in the last minute.
export function isDeliberate(rec, now = Date.now()) {
  return !!rec && (rec.reason === 'manual' || rec.reason === 'idle') && now - rec.at >= 0 && now - rec.at < DELIBERATE_WINDOW_MS;
}

const clock = (ms) => new Date(ms).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
const span = (ms) => {
  const m = Math.max(0, Math.round(ms / 60000));
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
};

// The sentence shown for a sign-out. `signedInAt` (ms) is the session's sign-in time when known.
export function signoutMessage(reason, { signedInAt = null, now = Date.now() } = {}) {
  if (reason === 'idle') return 'You were signed out after 60 minutes with no activity in any Wigley tab.';
  if (reason === 'ended') {
    return 'Your session was ended by the server — the session time limit, or a sign-out on another device.'
      + (signedInAt ? ` You signed in at ${clock(signedInAt)}, ${span(now - signedInAt)} ago.` : '');
  }
  return '';
}
